import img15a from '../../../assets/gallery/15d/15d-01-HOME_ST-9-2015-1524x3048mm-oleo-sobre-madera.jpg';

export const dataImages = [
  {
    id: 1,
    title: "",
    dimensions: "152,4 x 304,8 cm",
    pictureSrc: img15a,
    description: "2015",
    orientation: "h"
  },
].sort(() => Math.random() - 0.5);

export const dimensionsH = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


export const dimensionsV = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];



// WEBPACK FOOTER //
// ./src/pages/gallery/15d/data15d.js